/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../routes/__root'
import { Route as oauthRouteRouteImport } from './../../routes/(oauth)/route'
import { Route as marketingRouteRouteImport } from './../../routes/(marketing)/route'
import { Route as dashboardRouteRouteImport } from './../../routes/(dashboard)/route'
import { Route as authRouteRouteImport } from './../../routes/(auth)/route'
import { Route as marketingIndexRouteImport } from './../../routes/(marketing)/index'
import { Route as marketingTermsRouteImport } from './../../routes/(marketing)/terms'
import { Route as marketingSelfHostingRouteImport } from './../../routes/(marketing)/self-hosting'
import { Route as marketingPrivacyRouteImport } from './../../routes/(marketing)/privacy'
import { Route as marketingPricingRouteImport } from './../../routes/(marketing)/pricing'
import { Route as marketingFeaturesRouteImport } from './../../routes/(marketing)/features'
import { Route as marketingAboutRouteImport } from './../../routes/(marketing)/about'
import { Route as marketingSplatRouteImport } from './../../routes/(marketing)/$'
import { Route as authVerifyEmailRouteImport } from './../../routes/(auth)/verify-email'
import { Route as authVerifyAuthenticationRouteImport } from './../../routes/(auth)/verify-authentication'
import { Route as authResetPasswordRouteImport } from './../../routes/(auth)/reset-password'
import { Route as authRegisterRouteImport } from './../../routes/(auth)/register'
import { Route as authLoginRouteImport } from './../../routes/(auth)/login'
import { Route as authForgotPasswordRouteImport } from './../../routes/(auth)/forgot-password'
import { Route as oauthDashboardRouteRouteImport } from './../../routes/(oauth)/dashboard/route'
import { Route as oauthAuthRouteRouteImport } from './../../routes/(oauth)/auth/route'
import { Route as marketingChangelogRouteRouteImport } from './../../routes/(marketing)/changelog/route'
import { Route as marketingBlogRouteRouteImport } from './../../routes/(marketing)/blog/route'
import { Route as marketingRecipesIndexRouteImport } from './../../routes/(marketing)/recipes/index'
import { Route as marketingGuidesIndexRouteImport } from './../../routes/(marketing)/guides/index'
import { Route as marketingDocsIndexRouteImport } from './../../routes/(marketing)/docs/index'
import { Route as marketingCompareIndexRouteImport } from './../../routes/(marketing)/compare/index'
import { Route as marketingChangelogIndexRouteImport } from './../../routes/(marketing)/changelog/index'
import { Route as marketingBlogIndexRouteImport } from './../../routes/(marketing)/blog/index'
import { Route as dashboardDashboardIndexRouteImport } from './../../routes/(dashboard)/dashboard/index'
import { Route as oauthOauthConsentRouteImport } from './../../routes/(oauth)/oauth/consent'
import { Route as oauthAuthOutlookRouteImport } from './../../routes/(oauth)/auth/outlook'
import { Route as oauthAuthGoogleRouteImport } from './../../routes/(oauth)/auth/google'
import { Route as marketingToolsIcsViewerRouteImport } from './../../routes/(marketing)/tools/ics-viewer'
import { Route as marketingToolsIcsGeneratorRouteImport } from './../../routes/(marketing)/tools/ics-generator'
import { Route as marketingRecipesSlugRouteImport } from './../../routes/(marketing)/recipes/$slug'
import { Route as marketingGuidesSlugRouteImport } from './../../routes/(marketing)/guides/$slug'
import { Route as marketingDocsMcpRouteImport } from './../../routes/(marketing)/docs/mcp'
import { Route as marketingDocsSlugRouteImport } from './../../routes/(marketing)/docs/$slug'
import { Route as marketingCompareSlugRouteImport } from './../../routes/(marketing)/compare/$slug'
import { Route as marketingChangelogSlugRouteImport } from './../../routes/(marketing)/changelog/$slug'
import { Route as marketingBlogSlugRouteImport } from './../../routes/(marketing)/blog/$slug'
import { Route as dashboardDashboardReportRouteImport } from './../../routes/(dashboard)/dashboard/report'
import { Route as dashboardDashboardFeedbackRouteImport } from './../../routes/(dashboard)/dashboard/feedback'
import { Route as oauthDashboardConnectRouteRouteImport } from './../../routes/(oauth)/dashboard/connect/route'
import { Route as dashboardDashboardSettingsRouteRouteImport } from './../../routes/(dashboard)/dashboard/settings/route'
import { Route as dashboardDashboardIcalRouteRouteImport } from './../../routes/(dashboard)/dashboard/ical/route'
import { Route as dashboardDashboardConnectRouteRouteImport } from './../../routes/(dashboard)/dashboard/connect/route'
import { Route as dashboardDashboardAccountsRouteRouteImport } from './../../routes/(dashboard)/dashboard/accounts/route'
import { Route as dashboardDashboardUpgradeIndexRouteImport } from './../../routes/(dashboard)/dashboard/upgrade/index'
import { Route as dashboardDashboardSettingsIndexRouteImport } from './../../routes/(dashboard)/dashboard/settings/index'
import { Route as dashboardDashboardIntegrationsIndexRouteImport } from './../../routes/(dashboard)/dashboard/integrations/index'
import { Route as dashboardDashboardIcalIndexRouteImport } from './../../routes/(dashboard)/dashboard/ical/index'
import { Route as dashboardDashboardEventsIndexRouteImport } from './../../routes/(dashboard)/dashboard/events/index'
import { Route as dashboardDashboardConnectIndexRouteImport } from './../../routes/(dashboard)/dashboard/connect/index'
import { Route as oauthDashboardConnectOutlookRouteImport } from './../../routes/(oauth)/dashboard/connect/outlook'
import { Route as oauthDashboardConnectMicrosoftRouteImport } from './../../routes/(oauth)/dashboard/connect/microsoft'
import { Route as oauthDashboardConnectIcsFileRouteImport } from './../../routes/(oauth)/dashboard/connect/ics-file'
import { Route as oauthDashboardConnectIcalLinkRouteImport } from './../../routes/(oauth)/dashboard/connect/ical-link'
import { Route as oauthDashboardConnectGoogleRouteImport } from './../../routes/(oauth)/dashboard/connect/google'
import { Route as oauthDashboardConnectFastmailRouteImport } from './../../routes/(oauth)/dashboard/connect/fastmail'
import { Route as oauthDashboardConnectCaldavRouteImport } from './../../routes/(oauth)/dashboard/connect/caldav'
import { Route as oauthDashboardConnectAppleRouteImport } from './../../routes/(oauth)/dashboard/connect/apple'
import { Route as dashboardDashboardSettingsPasskeysRouteImport } from './../../routes/(dashboard)/dashboard/settings/passkeys'
import { Route as dashboardDashboardSettingsChangePasswordRouteImport } from './../../routes/(dashboard)/dashboard/settings/change-password'
import { Route as dashboardDashboardSettingsApiTokensRouteImport } from './../../routes/(dashboard)/dashboard/settings/api-tokens'
import { Route as dashboardDashboardIcalFeedIdRouteImport } from './../../routes/(dashboard)/dashboard/ical/$feedId'
import { Route as dashboardDashboardAccountsAccountIdIndexRouteImport } from './../../routes/(dashboard)/dashboard/accounts/$accountId.index'
import { Route as dashboardDashboardAccountsAccountIdSetupRouteImport } from './../../routes/(dashboard)/dashboard/accounts/$accountId.setup'
import { Route as dashboardDashboardAccountsAccountIdCalendarIdRouteImport } from './../../routes/(dashboard)/dashboard/accounts/$accountId.$calendarId'

const oauthRouteRoute = oauthRouteRouteImport.update({
  id: '/(oauth)',
  getParentRoute: () => rootRouteImport,
} as any)
const marketingRouteRoute = marketingRouteRouteImport.update({
  id: '/(marketing)',
  getParentRoute: () => rootRouteImport,
} as any)
const dashboardRouteRoute = dashboardRouteRouteImport.update({
  id: '/(dashboard)',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const marketingIndexRoute = marketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingTermsRoute = marketingTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingSelfHostingRoute = marketingSelfHostingRouteImport.update({
  id: '/self-hosting',
  path: '/self-hosting',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingPrivacyRoute = marketingPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingPricingRoute = marketingPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingFeaturesRoute = marketingFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingAboutRoute = marketingAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingSplatRoute = marketingSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => marketingRouteRoute,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => authRouteRoute,
} as any)
const authVerifyAuthenticationRoute =
  authVerifyAuthenticationRouteImport.update({
    id: '/verify-authentication',
    path: '/verify-authentication',
    getParentRoute: () => authRouteRoute,
  } as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authRegisterRoute = authRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => authRouteRoute,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authRouteRoute,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => authRouteRoute,
} as any)
const oauthDashboardRouteRoute = oauthDashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => oauthRouteRoute,
} as any)
const oauthAuthRouteRoute = oauthAuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => oauthRouteRoute,
} as any)
const marketingChangelogRouteRoute = marketingChangelogRouteRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingBlogRouteRoute = marketingBlogRouteRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingRecipesIndexRoute = marketingRecipesIndexRouteImport.update({
  id: '/recipes/',
  path: '/recipes/',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingGuidesIndexRoute = marketingGuidesIndexRouteImport.update({
  id: '/guides/',
  path: '/guides/',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingDocsIndexRoute = marketingDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingCompareIndexRoute = marketingCompareIndexRouteImport.update({
  id: '/compare/',
  path: '/compare/',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingChangelogIndexRoute = marketingChangelogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => marketingChangelogRouteRoute,
} as any)
const marketingBlogIndexRoute = marketingBlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => marketingBlogRouteRoute,
} as any)
const dashboardDashboardIndexRoute = dashboardDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => dashboardRouteRoute,
} as any)
const oauthOauthConsentRoute = oauthOauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => oauthRouteRoute,
} as any)
const oauthAuthOutlookRoute = oauthAuthOutlookRouteImport.update({
  id: '/outlook',
  path: '/outlook',
  getParentRoute: () => oauthAuthRouteRoute,
} as any)
const oauthAuthGoogleRoute = oauthAuthGoogleRouteImport.update({
  id: '/google',
  path: '/google',
  getParentRoute: () => oauthAuthRouteRoute,
} as any)
const marketingToolsIcsViewerRoute = marketingToolsIcsViewerRouteImport.update({
  id: '/tools/ics-viewer',
  path: '/tools/ics-viewer',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingToolsIcsGeneratorRoute =
  marketingToolsIcsGeneratorRouteImport.update({
    id: '/tools/ics-generator',
    path: '/tools/ics-generator',
    getParentRoute: () => marketingRouteRoute,
  } as any)
const marketingRecipesSlugRoute = marketingRecipesSlugRouteImport.update({
  id: '/recipes/$slug',
  path: '/recipes/$slug',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingGuidesSlugRoute = marketingGuidesSlugRouteImport.update({
  id: '/guides/$slug',
  path: '/guides/$slug',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingDocsMcpRoute = marketingDocsMcpRouteImport.update({
  id: '/docs/mcp',
  path: '/docs/mcp',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingDocsSlugRoute = marketingDocsSlugRouteImport.update({
  id: '/docs/$slug',
  path: '/docs/$slug',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingCompareSlugRoute = marketingCompareSlugRouteImport.update({
  id: '/compare/$slug',
  path: '/compare/$slug',
  getParentRoute: () => marketingRouteRoute,
} as any)
const marketingChangelogSlugRoute = marketingChangelogSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => marketingChangelogRouteRoute,
} as any)
const marketingBlogSlugRoute = marketingBlogSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => marketingBlogRouteRoute,
} as any)
const dashboardDashboardReportRoute =
  dashboardDashboardReportRouteImport.update({
    id: '/dashboard/report',
    path: '/dashboard/report',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardDashboardFeedbackRoute =
  dashboardDashboardFeedbackRouteImport.update({
    id: '/dashboard/feedback',
    path: '/dashboard/feedback',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const oauthDashboardConnectRouteRoute =
  oauthDashboardConnectRouteRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => oauthDashboardRouteRoute,
  } as any)
const dashboardDashboardSettingsRouteRoute =
  dashboardDashboardSettingsRouteRouteImport.update({
    id: '/dashboard/settings',
    path: '/dashboard/settings',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardDashboardIcalRouteRoute =
  dashboardDashboardIcalRouteRouteImport.update({
    id: '/dashboard/ical',
    path: '/dashboard/ical',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardDashboardConnectRouteRoute =
  dashboardDashboardConnectRouteRouteImport.update({
    id: '/dashboard/connect',
    path: '/dashboard/connect',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardDashboardAccountsRouteRoute =
  dashboardDashboardAccountsRouteRouteImport.update({
    id: '/dashboard/accounts',
    path: '/dashboard/accounts',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardDashboardUpgradeIndexRoute =
  dashboardDashboardUpgradeIndexRouteImport.update({
    id: '/dashboard/upgrade/',
    path: '/dashboard/upgrade/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardDashboardSettingsIndexRoute =
  dashboardDashboardSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardSettingsRouteRoute,
  } as any)
const dashboardDashboardIntegrationsIndexRoute =
  dashboardDashboardIntegrationsIndexRouteImport.update({
    id: '/dashboard/integrations/',
    path: '/dashboard/integrations/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardDashboardIcalIndexRoute =
  dashboardDashboardIcalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardIcalRouteRoute,
  } as any)
const dashboardDashboardEventsIndexRoute =
  dashboardDashboardEventsIndexRouteImport.update({
    id: '/dashboard/events/',
    path: '/dashboard/events/',
    getParentRoute: () => dashboardRouteRoute,
  } as any)
const dashboardDashboardConnectIndexRoute =
  dashboardDashboardConnectIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardConnectRouteRoute,
  } as any)
const oauthDashboardConnectOutlookRoute =
  oauthDashboardConnectOutlookRouteImport.update({
    id: '/outlook',
    path: '/outlook',
    getParentRoute: () => oauthDashboardConnectRouteRoute,
  } as any)
const oauthDashboardConnectMicrosoftRoute =
  oauthDashboardConnectMicrosoftRouteImport.update({
    id: '/microsoft',
    path: '/microsoft',
    getParentRoute: () => oauthDashboardConnectRouteRoute,
  } as any)
const oauthDashboardConnectIcsFileRoute =
  oauthDashboardConnectIcsFileRouteImport.update({
    id: '/ics-file',
    path: '/ics-file',
    getParentRoute: () => oauthDashboardConnectRouteRoute,
  } as any)
const oauthDashboardConnectIcalLinkRoute =
  oauthDashboardConnectIcalLinkRouteImport.update({
    id: '/ical-link',
    path: '/ical-link',
    getParentRoute: () => oauthDashboardConnectRouteRoute,
  } as any)
const oauthDashboardConnectGoogleRoute =
  oauthDashboardConnectGoogleRouteImport.update({
    id: '/google',
    path: '/google',
    getParentRoute: () => oauthDashboardConnectRouteRoute,
  } as any)
const oauthDashboardConnectFastmailRoute =
  oauthDashboardConnectFastmailRouteImport.update({
    id: '/fastmail',
    path: '/fastmail',
    getParentRoute: () => oauthDashboardConnectRouteRoute,
  } as any)
const oauthDashboardConnectCaldavRoute =
  oauthDashboardConnectCaldavRouteImport.update({
    id: '/caldav',
    path: '/caldav',
    getParentRoute: () => oauthDashboardConnectRouteRoute,
  } as any)
const oauthDashboardConnectAppleRoute =
  oauthDashboardConnectAppleRouteImport.update({
    id: '/apple',
    path: '/apple',
    getParentRoute: () => oauthDashboardConnectRouteRoute,
  } as any)
const dashboardDashboardSettingsPasskeysRoute =
  dashboardDashboardSettingsPasskeysRouteImport.update({
    id: '/passkeys',
    path: '/passkeys',
    getParentRoute: () => dashboardDashboardSettingsRouteRoute,
  } as any)
const dashboardDashboardSettingsChangePasswordRoute =
  dashboardDashboardSettingsChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => dashboardDashboardSettingsRouteRoute,
  } as any)
const dashboardDashboardSettingsApiTokensRoute =
  dashboardDashboardSettingsApiTokensRouteImport.update({
    id: '/api-tokens',
    path: '/api-tokens',
    getParentRoute: () => dashboardDashboardSettingsRouteRoute,
  } as any)
const dashboardDashboardIcalFeedIdRoute =
  dashboardDashboardIcalFeedIdRouteImport.update({
    id: '/$feedId',
    path: '/$feedId',
    getParentRoute: () => dashboardDashboardIcalRouteRoute,
  } as any)
const dashboardDashboardAccountsAccountIdIndexRoute =
  dashboardDashboardAccountsAccountIdIndexRouteImport.update({
    id: '/$accountId/',
    path: '/$accountId/',
    getParentRoute: () => dashboardDashboardAccountsRouteRoute,
  } as any)
const dashboardDashboardAccountsAccountIdSetupRoute =
  dashboardDashboardAccountsAccountIdSetupRouteImport.update({
    id: '/$accountId/setup',
    path: '/$accountId/setup',
    getParentRoute: () => dashboardDashboardAccountsRouteRoute,
  } as any)
const dashboardDashboardAccountsAccountIdCalendarIdRoute =
  dashboardDashboardAccountsAccountIdCalendarIdRouteImport.update({
    id: '/$accountId/$calendarId',
    path: '/$accountId/$calendarId',
    getParentRoute: () => dashboardDashboardAccountsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/blog': typeof marketingBlogRouteRouteWithChildren
  '/changelog': typeof marketingChangelogRouteRouteWithChildren
  '/auth': typeof oauthAuthRouteRouteWithChildren
  '/dashboard': typeof oauthDashboardRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/reset-password': typeof authResetPasswordRoute
  '/verify-authentication': typeof authVerifyAuthenticationRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/$': typeof marketingSplatRoute
  '/about': typeof marketingAboutRoute
  '/features': typeof marketingFeaturesRoute
  '/pricing': typeof marketingPricingRoute
  '/privacy': typeof marketingPrivacyRoute
  '/self-hosting': typeof marketingSelfHostingRoute
  '/terms': typeof marketingTermsRoute
  '/': typeof marketingIndexRoute
  '/dashboard/accounts': typeof dashboardDashboardAccountsRouteRouteWithChildren
  '/dashboard/connect': typeof oauthDashboardConnectRouteRouteWithChildren
  '/dashboard/ical': typeof dashboardDashboardIcalRouteRouteWithChildren
  '/dashboard/settings': typeof dashboardDashboardSettingsRouteRouteWithChildren
  '/dashboard/feedback': typeof dashboardDashboardFeedbackRoute
  '/dashboard/report': typeof dashboardDashboardReportRoute
  '/blog/$slug': typeof marketingBlogSlugRoute
  '/changelog/$slug': typeof marketingChangelogSlugRoute
  '/compare/$slug': typeof marketingCompareSlugRoute
  '/docs/$slug': typeof marketingDocsSlugRoute
  '/docs/mcp': typeof marketingDocsMcpRoute
  '/guides/$slug': typeof marketingGuidesSlugRoute
  '/recipes/$slug': typeof marketingRecipesSlugRoute
  '/tools/ics-generator': typeof marketingToolsIcsGeneratorRoute
  '/tools/ics-viewer': typeof marketingToolsIcsViewerRoute
  '/auth/google': typeof oauthAuthGoogleRoute
  '/auth/outlook': typeof oauthAuthOutlookRoute
  '/oauth/consent': typeof oauthOauthConsentRoute
  '/dashboard/': typeof dashboardDashboardIndexRoute
  '/blog/': typeof marketingBlogIndexRoute
  '/changelog/': typeof marketingChangelogIndexRoute
  '/compare/': typeof marketingCompareIndexRoute
  '/docs/': typeof marketingDocsIndexRoute
  '/guides/': typeof marketingGuidesIndexRoute
  '/recipes/': typeof marketingRecipesIndexRoute
  '/dashboard/ical/$feedId': typeof dashboardDashboardIcalFeedIdRoute
  '/dashboard/settings/api-tokens': typeof dashboardDashboardSettingsApiTokensRoute
  '/dashboard/settings/change-password': typeof dashboardDashboardSettingsChangePasswordRoute
  '/dashboard/settings/passkeys': typeof dashboardDashboardSettingsPasskeysRoute
  '/dashboard/connect/apple': typeof oauthDashboardConnectAppleRoute
  '/dashboard/connect/caldav': typeof oauthDashboardConnectCaldavRoute
  '/dashboard/connect/fastmail': typeof oauthDashboardConnectFastmailRoute
  '/dashboard/connect/google': typeof oauthDashboardConnectGoogleRoute
  '/dashboard/connect/ical-link': typeof oauthDashboardConnectIcalLinkRoute
  '/dashboard/connect/ics-file': typeof oauthDashboardConnectIcsFileRoute
  '/dashboard/connect/microsoft': typeof oauthDashboardConnectMicrosoftRoute
  '/dashboard/connect/outlook': typeof oauthDashboardConnectOutlookRoute
  '/dashboard/connect/': typeof dashboardDashboardConnectIndexRoute
  '/dashboard/events/': typeof dashboardDashboardEventsIndexRoute
  '/dashboard/ical/': typeof dashboardDashboardIcalIndexRoute
  '/dashboard/integrations/': typeof dashboardDashboardIntegrationsIndexRoute
  '/dashboard/settings/': typeof dashboardDashboardSettingsIndexRoute
  '/dashboard/upgrade/': typeof dashboardDashboardUpgradeIndexRoute
  '/dashboard/accounts/$accountId/$calendarId': typeof dashboardDashboardAccountsAccountIdCalendarIdRoute
  '/dashboard/accounts/$accountId/setup': typeof dashboardDashboardAccountsAccountIdSetupRoute
  '/dashboard/accounts/$accountId/': typeof dashboardDashboardAccountsAccountIdIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof oauthAuthRouteRouteWithChildren
  '/dashboard': typeof dashboardDashboardIndexRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/register': typeof authRegisterRoute
  '/reset-password': typeof authResetPasswordRoute
  '/verify-authentication': typeof authVerifyAuthenticationRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/$': typeof marketingSplatRoute
  '/about': typeof marketingAboutRoute
  '/features': typeof marketingFeaturesRoute
  '/pricing': typeof marketingPricingRoute
  '/privacy': typeof marketingPrivacyRoute
  '/self-hosting': typeof marketingSelfHostingRoute
  '/terms': typeof marketingTermsRoute
  '/': typeof marketingIndexRoute
  '/dashboard/accounts': typeof dashboardDashboardAccountsRouteRouteWithChildren
  '/dashboard/connect': typeof dashboardDashboardConnectIndexRoute
  '/dashboard/feedback': typeof dashboardDashboardFeedbackRoute
  '/dashboard/report': typeof dashboardDashboardReportRoute
  '/blog/$slug': typeof marketingBlogSlugRoute
  '/changelog/$slug': typeof marketingChangelogSlugRoute
  '/compare/$slug': typeof marketingCompareSlugRoute
  '/docs/$slug': typeof marketingDocsSlugRoute
  '/docs/mcp': typeof marketingDocsMcpRoute
  '/guides/$slug': typeof marketingGuidesSlugRoute
  '/recipes/$slug': typeof marketingRecipesSlugRoute
  '/tools/ics-generator': typeof marketingToolsIcsGeneratorRoute
  '/tools/ics-viewer': typeof marketingToolsIcsViewerRoute
  '/auth/google': typeof oauthAuthGoogleRoute
  '/auth/outlook': typeof oauthAuthOutlookRoute
  '/oauth/consent': typeof oauthOauthConsentRoute
  '/blog': typeof marketingBlogIndexRoute
  '/changelog': typeof marketingChangelogIndexRoute
  '/compare': typeof marketingCompareIndexRoute
  '/docs': typeof marketingDocsIndexRoute
  '/guides': typeof marketingGuidesIndexRoute
  '/recipes': typeof marketingRecipesIndexRoute
  '/dashboard/ical/$feedId': typeof dashboardDashboardIcalFeedIdRoute
  '/dashboard/settings/api-tokens': typeof dashboardDashboardSettingsApiTokensRoute
  '/dashboard/settings/change-password': typeof dashboardDashboardSettingsChangePasswordRoute
  '/dashboard/settings/passkeys': typeof dashboardDashboardSettingsPasskeysRoute
  '/dashboard/connect/apple': typeof oauthDashboardConnectAppleRoute
  '/dashboard/connect/caldav': typeof oauthDashboardConnectCaldavRoute
  '/dashboard/connect/fastmail': typeof oauthDashboardConnectFastmailRoute
  '/dashboard/connect/google': typeof oauthDashboardConnectGoogleRoute
  '/dashboard/connect/ical-link': typeof oauthDashboardConnectIcalLinkRoute
  '/dashboard/connect/ics-file': typeof oauthDashboardConnectIcsFileRoute
  '/dashboard/connect/microsoft': typeof oauthDashboardConnectMicrosoftRoute
  '/dashboard/connect/outlook': typeof oauthDashboardConnectOutlookRoute
  '/dashboard/events': typeof dashboardDashboardEventsIndexRoute
  '/dashboard/ical': typeof dashboardDashboardIcalIndexRoute
  '/dashboard/integrations': typeof dashboardDashboardIntegrationsIndexRoute
  '/dashboard/settings': typeof dashboardDashboardSettingsIndexRoute
  '/dashboard/upgrade': typeof dashboardDashboardUpgradeIndexRoute
  '/dashboard/accounts/$accountId/$calendarId': typeof dashboardDashboardAccountsAccountIdCalendarIdRoute
  '/dashboard/accounts/$accountId/setup': typeof dashboardDashboardAccountsAccountIdSetupRoute
  '/dashboard/accounts/$accountId': typeof dashboardDashboardAccountsAccountIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/(dashboard)': typeof dashboardRouteRouteWithChildren
  '/(marketing)': typeof marketingRouteRouteWithChildren
  '/(oauth)': typeof oauthRouteRouteWithChildren
  '/(marketing)/blog': typeof marketingBlogRouteRouteWithChildren
  '/(marketing)/changelog': typeof marketingChangelogRouteRouteWithChildren
  '/(oauth)/auth': typeof oauthAuthRouteRouteWithChildren
  '/(oauth)/dashboard': typeof oauthDashboardRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/register': typeof authRegisterRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/verify-authentication': typeof authVerifyAuthenticationRoute
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/(marketing)/$': typeof marketingSplatRoute
  '/(marketing)/about': typeof marketingAboutRoute
  '/(marketing)/features': typeof marketingFeaturesRoute
  '/(marketing)/pricing': typeof marketingPricingRoute
  '/(marketing)/privacy': typeof marketingPrivacyRoute
  '/(marketing)/self-hosting': typeof marketingSelfHostingRoute
  '/(marketing)/terms': typeof marketingTermsRoute
  '/(marketing)/': typeof marketingIndexRoute
  '/(dashboard)/dashboard/accounts': typeof dashboardDashboardAccountsRouteRouteWithChildren
  '/(dashboard)/dashboard/connect': typeof dashboardDashboardConnectRouteRouteWithChildren
  '/(dashboard)/dashboard/ical': typeof dashboardDashboardIcalRouteRouteWithChildren
  '/(dashboard)/dashboard/settings': typeof dashboardDashboardSettingsRouteRouteWithChildren
  '/(oauth)/dashboard/connect': typeof oauthDashboardConnectRouteRouteWithChildren
  '/(dashboard)/dashboard/feedback': typeof dashboardDashboardFeedbackRoute
  '/(dashboard)/dashboard/report': typeof dashboardDashboardReportRoute
  '/(marketing)/blog/$slug': typeof marketingBlogSlugRoute
  '/(marketing)/changelog/$slug': typeof marketingChangelogSlugRoute
  '/(marketing)/compare/$slug': typeof marketingCompareSlugRoute
  '/(marketing)/docs/$slug': typeof marketingDocsSlugRoute
  '/(marketing)/docs/mcp': typeof marketingDocsMcpRoute
  '/(marketing)/guides/$slug': typeof marketingGuidesSlugRoute
  '/(marketing)/recipes/$slug': typeof marketingRecipesSlugRoute
  '/(marketing)/tools/ics-generator': typeof marketingToolsIcsGeneratorRoute
  '/(marketing)/tools/ics-viewer': typeof marketingToolsIcsViewerRoute
  '/(oauth)/auth/google': typeof oauthAuthGoogleRoute
  '/(oauth)/auth/outlook': typeof oauthAuthOutlookRoute
  '/(oauth)/oauth/consent': typeof oauthOauthConsentRoute
  '/(dashboard)/dashboard/': typeof dashboardDashboardIndexRoute
  '/(marketing)/blog/': typeof marketingBlogIndexRoute
  '/(marketing)/changelog/': typeof marketingChangelogIndexRoute
  '/(marketing)/compare/': typeof marketingCompareIndexRoute
  '/(marketing)/docs/': typeof marketingDocsIndexRoute
  '/(marketing)/guides/': typeof marketingGuidesIndexRoute
  '/(marketing)/recipes/': typeof marketingRecipesIndexRoute
  '/(dashboard)/dashboard/ical/$feedId': typeof dashboardDashboardIcalFeedIdRoute
  '/(dashboard)/dashboard/settings/api-tokens': typeof dashboardDashboardSettingsApiTokensRoute
  '/(dashboard)/dashboard/settings/change-password': typeof dashboardDashboardSettingsChangePasswordRoute
  '/(dashboard)/dashboard/settings/passkeys': typeof dashboardDashboardSettingsPasskeysRoute
  '/(oauth)/dashboard/connect/apple': typeof oauthDashboardConnectAppleRoute
  '/(oauth)/dashboard/connect/caldav': typeof oauthDashboardConnectCaldavRoute
  '/(oauth)/dashboard/connect/fastmail': typeof oauthDashboardConnectFastmailRoute
  '/(oauth)/dashboard/connect/google': typeof oauthDashboardConnectGoogleRoute
  '/(oauth)/dashboard/connect/ical-link': typeof oauthDashboardConnectIcalLinkRoute
  '/(oauth)/dashboard/connect/ics-file': typeof oauthDashboardConnectIcsFileRoute
  '/(oauth)/dashboard/connect/microsoft': typeof oauthDashboardConnectMicrosoftRoute
  '/(oauth)/dashboard/connect/outlook': typeof oauthDashboardConnectOutlookRoute
  '/(dashboard)/dashboard/connect/': typeof dashboardDashboardConnectIndexRoute
  '/(dashboard)/dashboard/events/': typeof dashboardDashboardEventsIndexRoute
  '/(dashboard)/dashboard/ical/': typeof dashboardDashboardIcalIndexRoute
  '/(dashboard)/dashboard/integrations/': typeof dashboardDashboardIntegrationsIndexRoute
  '/(dashboard)/dashboard/settings/': typeof dashboardDashboardSettingsIndexRoute
  '/(dashboard)/dashboard/upgrade/': typeof dashboardDashboardUpgradeIndexRoute
  '/(dashboard)/dashboard/accounts/$accountId/$calendarId': typeof dashboardDashboardAccountsAccountIdCalendarIdRoute
  '/(dashboard)/dashboard/accounts/$accountId/setup': typeof dashboardDashboardAccountsAccountIdSetupRoute
  '/(dashboard)/dashboard/accounts/$accountId/': typeof dashboardDashboardAccountsAccountIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/blog'
    | '/changelog'
    | '/auth'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-authentication'
    | '/verify-email'
    | '/$'
    | '/about'
    | '/features'
    | '/pricing'
    | '/privacy'
    | '/self-hosting'
    | '/terms'
    | '/'
    | '/dashboard/accounts'
    | '/dashboard/connect'
    | '/dashboard/ical'
    | '/dashboard/settings'
    | '/dashboard/feedback'
    | '/dashboard/report'
    | '/blog/$slug'
    | '/changelog/$slug'
    | '/compare/$slug'
    | '/docs/$slug'
    | '/docs/mcp'
    | '/guides/$slug'
    | '/recipes/$slug'
    | '/tools/ics-generator'
    | '/tools/ics-viewer'
    | '/auth/google'
    | '/auth/outlook'
    | '/oauth/consent'
    | '/dashboard/'
    | '/blog/'
    | '/changelog/'
    | '/compare/'
    | '/docs/'
    | '/guides/'
    | '/recipes/'
    | '/dashboard/ical/$feedId'
    | '/dashboard/settings/api-tokens'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/passkeys'
    | '/dashboard/connect/apple'
    | '/dashboard/connect/caldav'
    | '/dashboard/connect/fastmail'
    | '/dashboard/connect/google'
    | '/dashboard/connect/ical-link'
    | '/dashboard/connect/ics-file'
    | '/dashboard/connect/microsoft'
    | '/dashboard/connect/outlook'
    | '/dashboard/connect/'
    | '/dashboard/events/'
    | '/dashboard/ical/'
    | '/dashboard/integrations/'
    | '/dashboard/settings/'
    | '/dashboard/upgrade/'
    | '/dashboard/accounts/$accountId/$calendarId'
    | '/dashboard/accounts/$accountId/setup'
    | '/dashboard/accounts/$accountId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/dashboard'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-authentication'
    | '/verify-email'
    | '/$'
    | '/about'
    | '/features'
    | '/pricing'
    | '/privacy'
    | '/self-hosting'
    | '/terms'
    | '/'
    | '/dashboard/accounts'
    | '/dashboard/connect'
    | '/dashboard/feedback'
    | '/dashboard/report'
    | '/blog/$slug'
    | '/changelog/$slug'
    | '/compare/$slug'
    | '/docs/$slug'
    | '/docs/mcp'
    | '/guides/$slug'
    | '/recipes/$slug'
    | '/tools/ics-generator'
    | '/tools/ics-viewer'
    | '/auth/google'
    | '/auth/outlook'
    | '/oauth/consent'
    | '/blog'
    | '/changelog'
    | '/compare'
    | '/docs'
    | '/guides'
    | '/recipes'
    | '/dashboard/ical/$feedId'
    | '/dashboard/settings/api-tokens'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/passkeys'
    | '/dashboard/connect/apple'
    | '/dashboard/connect/caldav'
    | '/dashboard/connect/fastmail'
    | '/dashboard/connect/google'
    | '/dashboard/connect/ical-link'
    | '/dashboard/connect/ics-file'
    | '/dashboard/connect/microsoft'
    | '/dashboard/connect/outlook'
    | '/dashboard/events'
    | '/dashboard/ical'
    | '/dashboard/integrations'
    | '/dashboard/settings'
    | '/dashboard/upgrade'
    | '/dashboard/accounts/$accountId/$calendarId'
    | '/dashboard/accounts/$accountId/setup'
    | '/dashboard/accounts/$accountId'
  id:
    | '__root__'
    | '/(auth)'
    | '/(dashboard)'
    | '/(marketing)'
    | '/(oauth)'
    | '/(marketing)/blog'
    | '/(marketing)/changelog'
    | '/(oauth)/auth'
    | '/(oauth)/dashboard'
    | '/(auth)/forgot-password'
    | '/(auth)/login'
    | '/(auth)/register'
    | '/(auth)/reset-password'
    | '/(auth)/verify-authentication'
    | '/(auth)/verify-email'
    | '/(marketing)/$'
    | '/(marketing)/about'
    | '/(marketing)/features'
    | '/(marketing)/pricing'
    | '/(marketing)/privacy'
    | '/(marketing)/self-hosting'
    | '/(marketing)/terms'
    | '/(marketing)/'
    | '/(dashboard)/dashboard/accounts'
    | '/(dashboard)/dashboard/connect'
    | '/(dashboard)/dashboard/ical'
    | '/(dashboard)/dashboard/settings'
    | '/(oauth)/dashboard/connect'
    | '/(dashboard)/dashboard/feedback'
    | '/(dashboard)/dashboard/report'
    | '/(marketing)/blog/$slug'
    | '/(marketing)/changelog/$slug'
    | '/(marketing)/compare/$slug'
    | '/(marketing)/docs/$slug'
    | '/(marketing)/docs/mcp'
    | '/(marketing)/guides/$slug'
    | '/(marketing)/recipes/$slug'
    | '/(marketing)/tools/ics-generator'
    | '/(marketing)/tools/ics-viewer'
    | '/(oauth)/auth/google'
    | '/(oauth)/auth/outlook'
    | '/(oauth)/oauth/consent'
    | '/(dashboard)/dashboard/'
    | '/(marketing)/blog/'
    | '/(marketing)/changelog/'
    | '/(marketing)/compare/'
    | '/(marketing)/docs/'
    | '/(marketing)/guides/'
    | '/(marketing)/recipes/'
    | '/(dashboard)/dashboard/ical/$feedId'
    | '/(dashboard)/dashboard/settings/api-tokens'
    | '/(dashboard)/dashboard/settings/change-password'
    | '/(dashboard)/dashboard/settings/passkeys'
    | '/(oauth)/dashboard/connect/apple'
    | '/(oauth)/dashboard/connect/caldav'
    | '/(oauth)/dashboard/connect/fastmail'
    | '/(oauth)/dashboard/connect/google'
    | '/(oauth)/dashboard/connect/ical-link'
    | '/(oauth)/dashboard/connect/ics-file'
    | '/(oauth)/dashboard/connect/microsoft'
    | '/(oauth)/dashboard/connect/outlook'
    | '/(dashboard)/dashboard/connect/'
    | '/(dashboard)/dashboard/events/'
    | '/(dashboard)/dashboard/ical/'
    | '/(dashboard)/dashboard/integrations/'
    | '/(dashboard)/dashboard/settings/'
    | '/(dashboard)/dashboard/upgrade/'
    | '/(dashboard)/dashboard/accounts/$accountId/$calendarId'
    | '/(dashboard)/dashboard/accounts/$accountId/setup'
    | '/(dashboard)/dashboard/accounts/$accountId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  dashboardRouteRoute: typeof dashboardRouteRouteWithChildren
  marketingRouteRoute: typeof marketingRouteRouteWithChildren
  oauthRouteRoute: typeof oauthRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(oauth)': {
      id: '/(oauth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof oauthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(marketing)': {
      id: '/(marketing)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof marketingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(dashboard)': {
      id: '/(dashboard)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof dashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(marketing)/': {
      id: '/(marketing)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof marketingIndexRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/terms': {
      id: '/(marketing)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof marketingTermsRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/self-hosting': {
      id: '/(marketing)/self-hosting'
      path: '/self-hosting'
      fullPath: '/self-hosting'
      preLoaderRoute: typeof marketingSelfHostingRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/privacy': {
      id: '/(marketing)/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof marketingPrivacyRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/pricing': {
      id: '/(marketing)/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof marketingPricingRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/features': {
      id: '/(marketing)/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof marketingFeaturesRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/about': {
      id: '/(marketing)/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof marketingAboutRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/$': {
      id: '/(marketing)/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof marketingSplatRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/verify-authentication': {
      id: '/(auth)/verify-authentication'
      path: '/verify-authentication'
      fullPath: '/verify-authentication'
      preLoaderRoute: typeof authVerifyAuthenticationRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/register': {
      id: '/(auth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authRegisterRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(oauth)/dashboard': {
      id: '/(oauth)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof oauthDashboardRouteRouteImport
      parentRoute: typeof oauthRouteRoute
    }
    '/(oauth)/auth': {
      id: '/(oauth)/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof oauthAuthRouteRouteImport
      parentRoute: typeof oauthRouteRoute
    }
    '/(marketing)/changelog': {
      id: '/(marketing)/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof marketingChangelogRouteRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/blog': {
      id: '/(marketing)/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof marketingBlogRouteRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/recipes/': {
      id: '/(marketing)/recipes/'
      path: '/recipes'
      fullPath: '/recipes/'
      preLoaderRoute: typeof marketingRecipesIndexRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/guides/': {
      id: '/(marketing)/guides/'
      path: '/guides'
      fullPath: '/guides/'
      preLoaderRoute: typeof marketingGuidesIndexRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/docs/': {
      id: '/(marketing)/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof marketingDocsIndexRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/compare/': {
      id: '/(marketing)/compare/'
      path: '/compare'
      fullPath: '/compare/'
      preLoaderRoute: typeof marketingCompareIndexRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/changelog/': {
      id: '/(marketing)/changelog/'
      path: '/'
      fullPath: '/changelog/'
      preLoaderRoute: typeof marketingChangelogIndexRouteImport
      parentRoute: typeof marketingChangelogRouteRoute
    }
    '/(marketing)/blog/': {
      id: '/(marketing)/blog/'
      path: '/'
      fullPath: '/blog/'
      preLoaderRoute: typeof marketingBlogIndexRouteImport
      parentRoute: typeof marketingBlogRouteRoute
    }
    '/(dashboard)/dashboard/': {
      id: '/(dashboard)/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof dashboardDashboardIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(oauth)/oauth/consent': {
      id: '/(oauth)/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof oauthOauthConsentRouteImport
      parentRoute: typeof oauthRouteRoute
    }
    '/(oauth)/auth/outlook': {
      id: '/(oauth)/auth/outlook'
      path: '/outlook'
      fullPath: '/auth/outlook'
      preLoaderRoute: typeof oauthAuthOutlookRouteImport
      parentRoute: typeof oauthAuthRouteRoute
    }
    '/(oauth)/auth/google': {
      id: '/(oauth)/auth/google'
      path: '/google'
      fullPath: '/auth/google'
      preLoaderRoute: typeof oauthAuthGoogleRouteImport
      parentRoute: typeof oauthAuthRouteRoute
    }
    '/(marketing)/tools/ics-viewer': {
      id: '/(marketing)/tools/ics-viewer'
      path: '/tools/ics-viewer'
      fullPath: '/tools/ics-viewer'
      preLoaderRoute: typeof marketingToolsIcsViewerRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/tools/ics-generator': {
      id: '/(marketing)/tools/ics-generator'
      path: '/tools/ics-generator'
      fullPath: '/tools/ics-generator'
      preLoaderRoute: typeof marketingToolsIcsGeneratorRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/recipes/$slug': {
      id: '/(marketing)/recipes/$slug'
      path: '/recipes/$slug'
      fullPath: '/recipes/$slug'
      preLoaderRoute: typeof marketingRecipesSlugRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/guides/$slug': {
      id: '/(marketing)/guides/$slug'
      path: '/guides/$slug'
      fullPath: '/guides/$slug'
      preLoaderRoute: typeof marketingGuidesSlugRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/docs/mcp': {
      id: '/(marketing)/docs/mcp'
      path: '/docs/mcp'
      fullPath: '/docs/mcp'
      preLoaderRoute: typeof marketingDocsMcpRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/docs/$slug': {
      id: '/(marketing)/docs/$slug'
      path: '/docs/$slug'
      fullPath: '/docs/$slug'
      preLoaderRoute: typeof marketingDocsSlugRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/compare/$slug': {
      id: '/(marketing)/compare/$slug'
      path: '/compare/$slug'
      fullPath: '/compare/$slug'
      preLoaderRoute: typeof marketingCompareSlugRouteImport
      parentRoute: typeof marketingRouteRoute
    }
    '/(marketing)/changelog/$slug': {
      id: '/(marketing)/changelog/$slug'
      path: '/$slug'
      fullPath: '/changelog/$slug'
      preLoaderRoute: typeof marketingChangelogSlugRouteImport
      parentRoute: typeof marketingChangelogRouteRoute
    }
    '/(marketing)/blog/$slug': {
      id: '/(marketing)/blog/$slug'
      path: '/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof marketingBlogSlugRouteImport
      parentRoute: typeof marketingBlogRouteRoute
    }
    '/(dashboard)/dashboard/report': {
      id: '/(dashboard)/dashboard/report'
      path: '/dashboard/report'
      fullPath: '/dashboard/report'
      preLoaderRoute: typeof dashboardDashboardReportRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/dashboard/feedback': {
      id: '/(dashboard)/dashboard/feedback'
      path: '/dashboard/feedback'
      fullPath: '/dashboard/feedback'
      preLoaderRoute: typeof dashboardDashboardFeedbackRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(oauth)/dashboard/connect': {
      id: '/(oauth)/dashboard/connect'
      path: '/connect'
      fullPath: '/dashboard/connect'
      preLoaderRoute: typeof oauthDashboardConnectRouteRouteImport
      parentRoute: typeof oauthDashboardRouteRoute
    }
    '/(dashboard)/dashboard/settings': {
      id: '/(dashboard)/dashboard/settings'
      path: '/dashboard/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof dashboardDashboardSettingsRouteRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/dashboard/ical': {
      id: '/(dashboard)/dashboard/ical'
      path: '/dashboard/ical'
      fullPath: '/dashboard/ical'
      preLoaderRoute: typeof dashboardDashboardIcalRouteRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/dashboard/connect': {
      id: '/(dashboard)/dashboard/connect'
      path: '/dashboard/connect'
      fullPath: '/dashboard/connect'
      preLoaderRoute: typeof dashboardDashboardConnectRouteRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/dashboard/accounts': {
      id: '/(dashboard)/dashboard/accounts'
      path: '/dashboard/accounts'
      fullPath: '/dashboard/accounts'
      preLoaderRoute: typeof dashboardDashboardAccountsRouteRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/dashboard/upgrade/': {
      id: '/(dashboard)/dashboard/upgrade/'
      path: '/dashboard/upgrade'
      fullPath: '/dashboard/upgrade/'
      preLoaderRoute: typeof dashboardDashboardUpgradeIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/dashboard/settings/': {
      id: '/(dashboard)/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof dashboardDashboardSettingsIndexRouteImport
      parentRoute: typeof dashboardDashboardSettingsRouteRoute
    }
    '/(dashboard)/dashboard/integrations/': {
      id: '/(dashboard)/dashboard/integrations/'
      path: '/dashboard/integrations'
      fullPath: '/dashboard/integrations/'
      preLoaderRoute: typeof dashboardDashboardIntegrationsIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/dashboard/ical/': {
      id: '/(dashboard)/dashboard/ical/'
      path: '/'
      fullPath: '/dashboard/ical/'
      preLoaderRoute: typeof dashboardDashboardIcalIndexRouteImport
      parentRoute: typeof dashboardDashboardIcalRouteRoute
    }
    '/(dashboard)/dashboard/events/': {
      id: '/(dashboard)/dashboard/events/'
      path: '/dashboard/events'
      fullPath: '/dashboard/events/'
      preLoaderRoute: typeof dashboardDashboardEventsIndexRouteImport
      parentRoute: typeof dashboardRouteRoute
    }
    '/(dashboard)/dashboard/connect/': {
      id: '/(dashboard)/dashboard/connect/'
      path: '/'
      fullPath: '/dashboard/connect/'
      preLoaderRoute: typeof dashboardDashboardConnectIndexRouteImport
      parentRoute: typeof dashboardDashboardConnectRouteRoute
    }
    '/(oauth)/dashboard/connect/outlook': {
      id: '/(oauth)/dashboard/connect/outlook'
      path: '/outlook'
      fullPath: '/dashboard/connect/outlook'
      preLoaderRoute: typeof oauthDashboardConnectOutlookRouteImport
      parentRoute: typeof oauthDashboardConnectRouteRoute
    }
    '/(oauth)/dashboard/connect/microsoft': {
      id: '/(oauth)/dashboard/connect/microsoft'
      path: '/microsoft'
      fullPath: '/dashboard/connect/microsoft'
      preLoaderRoute: typeof oauthDashboardConnectMicrosoftRouteImport
      parentRoute: typeof oauthDashboardConnectRouteRoute
    }
    '/(oauth)/dashboard/connect/ics-file': {
      id: '/(oauth)/dashboard/connect/ics-file'
      path: '/ics-file'
      fullPath: '/dashboard/connect/ics-file'
      preLoaderRoute: typeof oauthDashboardConnectIcsFileRouteImport
      parentRoute: typeof oauthDashboardConnectRouteRoute
    }
    '/(oauth)/dashboard/connect/ical-link': {
      id: '/(oauth)/dashboard/connect/ical-link'
      path: '/ical-link'
      fullPath: '/dashboard/connect/ical-link'
      preLoaderRoute: typeof oauthDashboardConnectIcalLinkRouteImport
      parentRoute: typeof oauthDashboardConnectRouteRoute
    }
    '/(oauth)/dashboard/connect/google': {
      id: '/(oauth)/dashboard/connect/google'
      path: '/google'
      fullPath: '/dashboard/connect/google'
      preLoaderRoute: typeof oauthDashboardConnectGoogleRouteImport
      parentRoute: typeof oauthDashboardConnectRouteRoute
    }
    '/(oauth)/dashboard/connect/fastmail': {
      id: '/(oauth)/dashboard/connect/fastmail'
      path: '/fastmail'
      fullPath: '/dashboard/connect/fastmail'
      preLoaderRoute: typeof oauthDashboardConnectFastmailRouteImport
      parentRoute: typeof oauthDashboardConnectRouteRoute
    }
    '/(oauth)/dashboard/connect/caldav': {
      id: '/(oauth)/dashboard/connect/caldav'
      path: '/caldav'
      fullPath: '/dashboard/connect/caldav'
      preLoaderRoute: typeof oauthDashboardConnectCaldavRouteImport
      parentRoute: typeof oauthDashboardConnectRouteRoute
    }
    '/(oauth)/dashboard/connect/apple': {
      id: '/(oauth)/dashboard/connect/apple'
      path: '/apple'
      fullPath: '/dashboard/connect/apple'
      preLoaderRoute: typeof oauthDashboardConnectAppleRouteImport
      parentRoute: typeof oauthDashboardConnectRouteRoute
    }
    '/(dashboard)/dashboard/settings/passkeys': {
      id: '/(dashboard)/dashboard/settings/passkeys'
      path: '/passkeys'
      fullPath: '/dashboard/settings/passkeys'
      preLoaderRoute: typeof dashboardDashboardSettingsPasskeysRouteImport
      parentRoute: typeof dashboardDashboardSettingsRouteRoute
    }
    '/(dashboard)/dashboard/settings/change-password': {
      id: '/(dashboard)/dashboard/settings/change-password'
      path: '/change-password'
      fullPath: '/dashboard/settings/change-password'
      preLoaderRoute: typeof dashboardDashboardSettingsChangePasswordRouteImport
      parentRoute: typeof dashboardDashboardSettingsRouteRoute
    }
    '/(dashboard)/dashboard/settings/api-tokens': {
      id: '/(dashboard)/dashboard/settings/api-tokens'
      path: '/api-tokens'
      fullPath: '/dashboard/settings/api-tokens'
      preLoaderRoute: typeof dashboardDashboardSettingsApiTokensRouteImport
      parentRoute: typeof dashboardDashboardSettingsRouteRoute
    }
    '/(dashboard)/dashboard/ical/$feedId': {
      id: '/(dashboard)/dashboard/ical/$feedId'
      path: '/$feedId'
      fullPath: '/dashboard/ical/$feedId'
      preLoaderRoute: typeof dashboardDashboardIcalFeedIdRouteImport
      parentRoute: typeof dashboardDashboardIcalRouteRoute
    }
    '/(dashboard)/dashboard/accounts/$accountId/': {
      id: '/(dashboard)/dashboard/accounts/$accountId/'
      path: '/$accountId'
      fullPath: '/dashboard/accounts/$accountId/'
      preLoaderRoute: typeof dashboardDashboardAccountsAccountIdIndexRouteImport
      parentRoute: typeof dashboardDashboardAccountsRouteRoute
    }
    '/(dashboard)/dashboard/accounts/$accountId/setup': {
      id: '/(dashboard)/dashboard/accounts/$accountId/setup'
      path: '/$accountId/setup'
      fullPath: '/dashboard/accounts/$accountId/setup'
      preLoaderRoute: typeof dashboardDashboardAccountsAccountIdSetupRouteImport
      parentRoute: typeof dashboardDashboardAccountsRouteRoute
    }
    '/(dashboard)/dashboard/accounts/$accountId/$calendarId': {
      id: '/(dashboard)/dashboard/accounts/$accountId/$calendarId'
      path: '/$accountId/$calendarId'
      fullPath: '/dashboard/accounts/$accountId/$calendarId'
      preLoaderRoute: typeof dashboardDashboardAccountsAccountIdCalendarIdRouteImport
      parentRoute: typeof dashboardDashboardAccountsRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authLoginRoute: typeof authLoginRoute
  authRegisterRoute: typeof authRegisterRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authVerifyAuthenticationRoute: typeof authVerifyAuthenticationRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLoginRoute: authLoginRoute,
  authRegisterRoute: authRegisterRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authVerifyAuthenticationRoute: authVerifyAuthenticationRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface dashboardDashboardAccountsRouteRouteChildren {
  dashboardDashboardAccountsAccountIdCalendarIdRoute: typeof dashboardDashboardAccountsAccountIdCalendarIdRoute
  dashboardDashboardAccountsAccountIdSetupRoute: typeof dashboardDashboardAccountsAccountIdSetupRoute
  dashboardDashboardAccountsAccountIdIndexRoute: typeof dashboardDashboardAccountsAccountIdIndexRoute
}

const dashboardDashboardAccountsRouteRouteChildren: dashboardDashboardAccountsRouteRouteChildren =
  {
    dashboardDashboardAccountsAccountIdCalendarIdRoute:
      dashboardDashboardAccountsAccountIdCalendarIdRoute,
    dashboardDashboardAccountsAccountIdSetupRoute:
      dashboardDashboardAccountsAccountIdSetupRoute,
    dashboardDashboardAccountsAccountIdIndexRoute:
      dashboardDashboardAccountsAccountIdIndexRoute,
  }

const dashboardDashboardAccountsRouteRouteWithChildren =
  dashboardDashboardAccountsRouteRoute._addFileChildren(
    dashboardDashboardAccountsRouteRouteChildren,
  )

interface dashboardDashboardConnectRouteRouteChildren {
  dashboardDashboardConnectIndexRoute: typeof dashboardDashboardConnectIndexRoute
}

const dashboardDashboardConnectRouteRouteChildren: dashboardDashboardConnectRouteRouteChildren =
  {
    dashboardDashboardConnectIndexRoute: dashboardDashboardConnectIndexRoute,
  }

const dashboardDashboardConnectRouteRouteWithChildren =
  dashboardDashboardConnectRouteRoute._addFileChildren(
    dashboardDashboardConnectRouteRouteChildren,
  )

interface dashboardDashboardIcalRouteRouteChildren {
  dashboardDashboardIcalFeedIdRoute: typeof dashboardDashboardIcalFeedIdRoute
  dashboardDashboardIcalIndexRoute: typeof dashboardDashboardIcalIndexRoute
}

const dashboardDashboardIcalRouteRouteChildren: dashboardDashboardIcalRouteRouteChildren =
  {
    dashboardDashboardIcalFeedIdRoute: dashboardDashboardIcalFeedIdRoute,
    dashboardDashboardIcalIndexRoute: dashboardDashboardIcalIndexRoute,
  }

const dashboardDashboardIcalRouteRouteWithChildren =
  dashboardDashboardIcalRouteRoute._addFileChildren(
    dashboardDashboardIcalRouteRouteChildren,
  )

interface dashboardDashboardSettingsRouteRouteChildren {
  dashboardDashboardSettingsApiTokensRoute: typeof dashboardDashboardSettingsApiTokensRoute
  dashboardDashboardSettingsChangePasswordRoute: typeof dashboardDashboardSettingsChangePasswordRoute
  dashboardDashboardSettingsPasskeysRoute: typeof dashboardDashboardSettingsPasskeysRoute
  dashboardDashboardSettingsIndexRoute: typeof dashboardDashboardSettingsIndexRoute
}

const dashboardDashboardSettingsRouteRouteChildren: dashboardDashboardSettingsRouteRouteChildren =
  {
    dashboardDashboardSettingsApiTokensRoute:
      dashboardDashboardSettingsApiTokensRoute,
    dashboardDashboardSettingsChangePasswordRoute:
      dashboardDashboardSettingsChangePasswordRoute,
    dashboardDashboardSettingsPasskeysRoute:
      dashboardDashboardSettingsPasskeysRoute,
    dashboardDashboardSettingsIndexRoute: dashboardDashboardSettingsIndexRoute,
  }

const dashboardDashboardSettingsRouteRouteWithChildren =
  dashboardDashboardSettingsRouteRoute._addFileChildren(
    dashboardDashboardSettingsRouteRouteChildren,
  )

interface dashboardRouteRouteChildren {
  dashboardDashboardAccountsRouteRoute: typeof dashboardDashboardAccountsRouteRouteWithChildren
  dashboardDashboardConnectRouteRoute: typeof dashboardDashboardConnectRouteRouteWithChildren
  dashboardDashboardIcalRouteRoute: typeof dashboardDashboardIcalRouteRouteWithChildren
  dashboardDashboardSettingsRouteRoute: typeof dashboardDashboardSettingsRouteRouteWithChildren
  dashboardDashboardFeedbackRoute: typeof dashboardDashboardFeedbackRoute
  dashboardDashboardReportRoute: typeof dashboardDashboardReportRoute
  dashboardDashboardIndexRoute: typeof dashboardDashboardIndexRoute
  dashboardDashboardEventsIndexRoute: typeof dashboardDashboardEventsIndexRoute
  dashboardDashboardIntegrationsIndexRoute: typeof dashboardDashboardIntegrationsIndexRoute
  dashboardDashboardUpgradeIndexRoute: typeof dashboardDashboardUpgradeIndexRoute
}

const dashboardRouteRouteChildren: dashboardRouteRouteChildren = {
  dashboardDashboardAccountsRouteRoute:
    dashboardDashboardAccountsRouteRouteWithChildren,
  dashboardDashboardConnectRouteRoute:
    dashboardDashboardConnectRouteRouteWithChildren,
  dashboardDashboardIcalRouteRoute:
    dashboardDashboardIcalRouteRouteWithChildren,
  dashboardDashboardSettingsRouteRoute:
    dashboardDashboardSettingsRouteRouteWithChildren,
  dashboardDashboardFeedbackRoute: dashboardDashboardFeedbackRoute,
  dashboardDashboardReportRoute: dashboardDashboardReportRoute,
  dashboardDashboardIndexRoute: dashboardDashboardIndexRoute,
  dashboardDashboardEventsIndexRoute: dashboardDashboardEventsIndexRoute,
  dashboardDashboardIntegrationsIndexRoute:
    dashboardDashboardIntegrationsIndexRoute,
  dashboardDashboardUpgradeIndexRoute: dashboardDashboardUpgradeIndexRoute,
}

const dashboardRouteRouteWithChildren = dashboardRouteRoute._addFileChildren(
  dashboardRouteRouteChildren,
)

interface marketingBlogRouteRouteChildren {
  marketingBlogSlugRoute: typeof marketingBlogSlugRoute
  marketingBlogIndexRoute: typeof marketingBlogIndexRoute
}

const marketingBlogRouteRouteChildren: marketingBlogRouteRouteChildren = {
  marketingBlogSlugRoute: marketingBlogSlugRoute,
  marketingBlogIndexRoute: marketingBlogIndexRoute,
}

const marketingBlogRouteRouteWithChildren =
  marketingBlogRouteRoute._addFileChildren(marketingBlogRouteRouteChildren)

interface marketingChangelogRouteRouteChildren {
  marketingChangelogSlugRoute: typeof marketingChangelogSlugRoute
  marketingChangelogIndexRoute: typeof marketingChangelogIndexRoute
}

const marketingChangelogRouteRouteChildren: marketingChangelogRouteRouteChildren =
  {
    marketingChangelogSlugRoute: marketingChangelogSlugRoute,
    marketingChangelogIndexRoute: marketingChangelogIndexRoute,
  }

const marketingChangelogRouteRouteWithChildren =
  marketingChangelogRouteRoute._addFileChildren(
    marketingChangelogRouteRouteChildren,
  )

interface marketingRouteRouteChildren {
  marketingBlogRouteRoute: typeof marketingBlogRouteRouteWithChildren
  marketingChangelogRouteRoute: typeof marketingChangelogRouteRouteWithChildren
  marketingSplatRoute: typeof marketingSplatRoute
  marketingAboutRoute: typeof marketingAboutRoute
  marketingFeaturesRoute: typeof marketingFeaturesRoute
  marketingPricingRoute: typeof marketingPricingRoute
  marketingPrivacyRoute: typeof marketingPrivacyRoute
  marketingSelfHostingRoute: typeof marketingSelfHostingRoute
  marketingTermsRoute: typeof marketingTermsRoute
  marketingIndexRoute: typeof marketingIndexRoute
  marketingCompareSlugRoute: typeof marketingCompareSlugRoute
  marketingDocsSlugRoute: typeof marketingDocsSlugRoute
  marketingDocsMcpRoute: typeof marketingDocsMcpRoute
  marketingGuidesSlugRoute: typeof marketingGuidesSlugRoute
  marketingRecipesSlugRoute: typeof marketingRecipesSlugRoute
  marketingToolsIcsGeneratorRoute: typeof marketingToolsIcsGeneratorRoute
  marketingToolsIcsViewerRoute: typeof marketingToolsIcsViewerRoute
  marketingCompareIndexRoute: typeof marketingCompareIndexRoute
  marketingDocsIndexRoute: typeof marketingDocsIndexRoute
  marketingGuidesIndexRoute: typeof marketingGuidesIndexRoute
  marketingRecipesIndexRoute: typeof marketingRecipesIndexRoute
}

const marketingRouteRouteChildren: marketingRouteRouteChildren = {
  marketingBlogRouteRoute: marketingBlogRouteRouteWithChildren,
  marketingChangelogRouteRoute: marketingChangelogRouteRouteWithChildren,
  marketingSplatRoute: marketingSplatRoute,
  marketingAboutRoute: marketingAboutRoute,
  marketingFeaturesRoute: marketingFeaturesRoute,
  marketingPricingRoute: marketingPricingRoute,
  marketingPrivacyRoute: marketingPrivacyRoute,
  marketingSelfHostingRoute: marketingSelfHostingRoute,
  marketingTermsRoute: marketingTermsRoute,
  marketingIndexRoute: marketingIndexRoute,
  marketingCompareSlugRoute: marketingCompareSlugRoute,
  marketingDocsSlugRoute: marketingDocsSlugRoute,
  marketingDocsMcpRoute: marketingDocsMcpRoute,
  marketingGuidesSlugRoute: marketingGuidesSlugRoute,
  marketingRecipesSlugRoute: marketingRecipesSlugRoute,
  marketingToolsIcsGeneratorRoute: marketingToolsIcsGeneratorRoute,
  marketingToolsIcsViewerRoute: marketingToolsIcsViewerRoute,
  marketingCompareIndexRoute: marketingCompareIndexRoute,
  marketingDocsIndexRoute: marketingDocsIndexRoute,
  marketingGuidesIndexRoute: marketingGuidesIndexRoute,
  marketingRecipesIndexRoute: marketingRecipesIndexRoute,
}

const marketingRouteRouteWithChildren = marketingRouteRoute._addFileChildren(
  marketingRouteRouteChildren,
)

interface oauthAuthRouteRouteChildren {
  oauthAuthGoogleRoute: typeof oauthAuthGoogleRoute
  oauthAuthOutlookRoute: typeof oauthAuthOutlookRoute
}

const oauthAuthRouteRouteChildren: oauthAuthRouteRouteChildren = {
  oauthAuthGoogleRoute: oauthAuthGoogleRoute,
  oauthAuthOutlookRoute: oauthAuthOutlookRoute,
}

const oauthAuthRouteRouteWithChildren = oauthAuthRouteRoute._addFileChildren(
  oauthAuthRouteRouteChildren,
)

interface oauthDashboardConnectRouteRouteChildren {
  oauthDashboardConnectAppleRoute: typeof oauthDashboardConnectAppleRoute
  oauthDashboardConnectCaldavRoute: typeof oauthDashboardConnectCaldavRoute
  oauthDashboardConnectFastmailRoute: typeof oauthDashboardConnectFastmailRoute
  oauthDashboardConnectGoogleRoute: typeof oauthDashboardConnectGoogleRoute
  oauthDashboardConnectIcalLinkRoute: typeof oauthDashboardConnectIcalLinkRoute
  oauthDashboardConnectIcsFileRoute: typeof oauthDashboardConnectIcsFileRoute
  oauthDashboardConnectMicrosoftRoute: typeof oauthDashboardConnectMicrosoftRoute
  oauthDashboardConnectOutlookRoute: typeof oauthDashboardConnectOutlookRoute
}

const oauthDashboardConnectRouteRouteChildren: oauthDashboardConnectRouteRouteChildren =
  {
    oauthDashboardConnectAppleRoute: oauthDashboardConnectAppleRoute,
    oauthDashboardConnectCaldavRoute: oauthDashboardConnectCaldavRoute,
    oauthDashboardConnectFastmailRoute: oauthDashboardConnectFastmailRoute,
    oauthDashboardConnectGoogleRoute: oauthDashboardConnectGoogleRoute,
    oauthDashboardConnectIcalLinkRoute: oauthDashboardConnectIcalLinkRoute,
    oauthDashboardConnectIcsFileRoute: oauthDashboardConnectIcsFileRoute,
    oauthDashboardConnectMicrosoftRoute: oauthDashboardConnectMicrosoftRoute,
    oauthDashboardConnectOutlookRoute: oauthDashboardConnectOutlookRoute,
  }

const oauthDashboardConnectRouteRouteWithChildren =
  oauthDashboardConnectRouteRoute._addFileChildren(
    oauthDashboardConnectRouteRouteChildren,
  )

interface oauthDashboardRouteRouteChildren {
  oauthDashboardConnectRouteRoute: typeof oauthDashboardConnectRouteRouteWithChildren
}

const oauthDashboardRouteRouteChildren: oauthDashboardRouteRouteChildren = {
  oauthDashboardConnectRouteRoute: oauthDashboardConnectRouteRouteWithChildren,
}

const oauthDashboardRouteRouteWithChildren =
  oauthDashboardRouteRoute._addFileChildren(oauthDashboardRouteRouteChildren)

interface oauthRouteRouteChildren {
  oauthAuthRouteRoute: typeof oauthAuthRouteRouteWithChildren
  oauthDashboardRouteRoute: typeof oauthDashboardRouteRouteWithChildren
  oauthOauthConsentRoute: typeof oauthOauthConsentRoute
}

const oauthRouteRouteChildren: oauthRouteRouteChildren = {
  oauthAuthRouteRoute: oauthAuthRouteRouteWithChildren,
  oauthDashboardRouteRoute: oauthDashboardRouteRouteWithChildren,
  oauthOauthConsentRoute: oauthOauthConsentRoute,
}

const oauthRouteRouteWithChildren = oauthRouteRoute._addFileChildren(
  oauthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  dashboardRouteRoute: dashboardRouteRouteWithChildren,
  marketingRouteRoute: marketingRouteRouteWithChildren,
  oauthRouteRoute: oauthRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
